import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly4C2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4C/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4C/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4C/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4C/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4C/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/4C/6.webp`;

  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                   Topic: Make Hay While the Sun Shines
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 4C      Date: 30,31 July 2026
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
 The students of Class 4 C presented an awe-inspiring morning assembly on the topic, ‘Make Hay While the Sun Shines’ on Thursday,
  30 July 2026 and Friday, 31 July 2026.  
<br></br>
   The assembly began with an inspiring thought for the day, followed by a brief introduction emphasising
    the importance of hard work, discipline, responsible behaviour and planning for the future. Students performed a musical enactment of the story, 
    "The Ant and the Grasshopper." Through acting, songs and colourful properties, they brought the story to life, delivering a strong message 
    that effort and discipline lead to success. The students impressed everyone with their enthusiasm and teamwork. The assembly concluded with a reminder that small, 
    dedicated steps today build a better, successful tomorrow, inspiring all to value the wise use of time.
        <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
    "Time well spent today becomes success tomorrow."
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 4C 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly4C2026;
